
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { singularityStore } from "@/store/store";
import SectionAddOrSwapPanel from "./SectionAddOrSwap/SectionAddOrSwapPanel.vue";
import SectionWriter from "./SectionWriter/SectionWriter.vue";
import AIJobManager from "./AIJobManager/AIJobManager.vue";
import PageStructureNew from "./PageStructure/PageStructureNew.vue";
import ImageEditor from "./ImageEditor/ImageEditor.vue";
import BackgroundImageEditor from "./BackgroundImageEditor/BackgroundImageEditor.vue";
import IconEditor from "./IconEditor/IconEditor.vue";
import TextEditor from "./TextEditor/TextEditor.vue";
import LinkEditor from "./LinkEditor/LinkEditor.vue";
import ContentPropertiesEditor from "./ContentPropertiesEditor/ContentPropertiesEditor.vue";
import WPPageManagerNew from "./WPPageManager/WPPageManagerNew.vue";
import SettingsPanel from "./Settings/SettingsPanel.vue";
import BrandPanel from "./Brand/BrandPanel.vue";
import BrandPanelColorEdit from "./Brand/Color/BrandPanelColorEdit.vue";
import BrandPanelTypographyEdit from "./Brand/Typography/BrandPanelTypographyEdit.vue";
import { fetchBrandSettings } from "@/lib/singularity/brand/settings";

@Component({
  components: {
    SectionAddOrSwapPanel,
    SectionWriter,
    AIJobManager,
    PageStructureNew,
    ImageEditor,
    BackgroundImageEditor,
    IconEditor,
    TextEditor,
    LinkEditor,
    ContentPropertiesEditor,
    WPPageManagerNew,
    SettingsPanel,
    BrandPanel,
    BrandPanelColorEdit,
    BrandPanelTypographyEdit
  }
})
export default class SingularityLeftPanel extends Vue {
  get singularityLeftPanelState() {
    return singularityStore.singularityUiState.singularityLeftPanel;
  }

  get singularityDebugPanelOpen() {
    return !!singularityStore.singularityUiState.singularityDebugPanel;
  }

  get imageEditorKey() {
    return singularityStore.imageEditorPanelState?.imageId || 'no-image';
  }

  mounted() {
    fetchBrandSettings();
  }
}
